import React from 'react';
import { Box, Text } from '@clariness/clarikit-react';

export const AuthPageLayoutHeading: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <Box style={{ marginBottom: '36px' }}>
      <Text as="h3" variant="headingSm">
        {children}
      </Text>
    </Box>
  );
};
